import React from "react";

function TableRenderer({ table }) {

    if (!table) {

        return null;

    }

    const title =
        table.title || "Results";

    const columns =
        table.columns || [];

    const rows =
        table.rows || [];

    return (

        <div
            style={{

                marginTop: 10,

                marginBottom: 20,

                border: "1px solid #ddd",

                borderRadius: 8,

                overflow: "hidden",

                background: "#fff"

            }}
        >

            <div
                style={{

                    padding: "10px 14px",

                    fontWeight: "bold",

                    background: "#f5f7fb",

                    borderBottom: "1px solid #ddd"

                }}
            >

                {title}

            </div>

            <div
                style={{

                    overflowX: "auto"

                }}
            >

                <table
                    style={{

                        width: "100%",

                        borderCollapse: "collapse",

                        fontSize: 14

                    }}
                >

                    <thead>

                        <tr>

                            {

                                columns.map(

                                    column => (

                                        <th

                                            key={column}

                                            style={{

                                                padding: 10,

                                                textAlign: "left",

                                                background: "#fafafa",

                                                borderBottom: "1px solid #ddd",

                                                whiteSpace: "nowrap"

                                            }}

                                        >

                                            {column}

                                        </th>

                                    )

                                )

                            }

                        </tr>

                    </thead>

                    <tbody>

                        {

                            rows.length === 0

                                ?

                                (

                                    <tr>

                                        <td

                                            colSpan={columns.length}

                                            style={{

                                                padding: 20,

                                                textAlign: "center",

                                                color: "#777"

                                            }}

                                        >

                                            No records found.

                                        </td>

                                    </tr>

                                )

                                :

                                rows.map(

                                    (row, index) => (

                                        <tr

                                            key={index}

                                        >

                                            {

                                                columns.map(

                                                    column => (

                                                        <td

                                                            key={column}

                                                            style={{

                                                                padding: 8,

                                                                borderBottom: "1px solid #eee",

                                                                whiteSpace: "nowrap"

                                                            }}

                                                        >

                                                            {

                                                                row[column] === null ||

                                                                row[column] === undefined

                                                                    ?

                                                                    ""

                                                                    :

                                                                    String(

                                                                        row[column]

                                                                    )

                                                            }

                                                        </td>

                                                    )

                                                )

                                            }

                                        </tr>

                                    )

                                )

                        }

                    </tbody>

                </table>

            </div>

            <div

                style={{

                    padding: 10,

                    fontSize: 12,

                    color: "#777",

                    borderTop: "1px solid #eee",

                    background: "#fafafa"

                }}

            >

                {rows.length} record(s)

            </div>

        </div>

    );

}

export default TableRenderer;